import PropTypes from 'prop-types';
import React from 'react';
import ColorBox from './ColorBox';

export default function ColorPicker({ options, onChange, chosenElementIndex }) {
  return (
    <>
      <p className="bop-colorPicker__choice">
        {chosenElementIndex === undefined
          ? <strong>Choose colour:</strong>
          : <><strong>Selected colour:</strong> {options[chosenElementIndex].name}</>}
      </p>
      <div className="bop-colorPicker__wrapper">
        {options && options.map(option => (
          <label
            key={option.name}
            htmlFor={option.name}
            className="bop-colorPickerItem"
          >
            <input
              onChange={() => { onChange(option.name, option.value); }}
              id={option.name}
              type="radio"
              name="colorPickerGroup"
              disabled={option.disabled}
              checked={option.checked}
            />
            <ColorBox colourCode={`#${option.colourCode}`} colourName={option.name} />
          </label>))}
      </div>
    </>);
}

ColorPicker.propTypes = {
  options: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string,
    value: PropTypes.string,
    colorCode: PropTypes.string,
    isDisabled: PropTypes.bool,
  })).isRequired,
  chosenElementIndex: PropTypes.string,
};
